import { useParams, useHistory } from 'react-router-dom'
import { Container, Row, Spinner, Button } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import parse from 'html-react-parser'
import { getCopingSkillsData } from '../../../common/api/Practices'
import LessonVideo from 'components/lessons/LessonVideo'
import { ROUTE_ACTIVITIES_COPINGSKILLS_ALL } from 'components/common/helpers/Paths'
import { navigateTo } from '../../../common/navigation'
import {
  saveUserEvent,
  EVENT_CATEGORY_COPING_SKILLS,
  EVENT_ACTION_PAGEVIEW
} from 'components/common/api/UserEvents'
import Author from '../../Author/Author'
import './CopingskillsFullScreen.scss'
import cn from 'classnames'
import { useMediaQuery } from 'react-responsive'

export default function CopingskillsFullScreen({
  setReturnPath,
  setHeaderTitle
}) {
  const { copingSkillsId } = useParams()
  const [copingSkills, setCopingSkills] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const history = useHistory()
  const returnPath = `${ROUTE_ACTIVITIES_COPINGSKILLS_ALL}/intro/${copingSkillsId}/`
  const [author, setAuthor] = useState([])
  const isMediumScreen = useMediaQuery({ maxWidth: 768 })

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Update Header
    setHeaderTitle(null)
    setReturnPath(returnPath)

    async function getCopingSkillsDataAsync() {
      const activityResult = await getCopingSkillsData(copingSkillsId)
      setCopingSkills(activityResult)

      setIsLoading(false)
      setAuthor(activityResult.contentAuthor)
    }
    getCopingSkillsDataAsync()

    // Log access
    saveUserEvent(
      EVENT_CATEGORY_COPING_SKILLS,
      EVENT_ACTION_PAGEVIEW,
      copingSkillsId
    )
  }, [copingSkillsId, returnPath, setReturnPath, setHeaderTitle, author])

  const handleClick = () => {
    navigateTo(returnPath, history)
  }

  return (
    <>
      {isLoading ? (
        <Row>
          <Spinner
            animation='border'
            role='status'
            className='app-spinner'
            variant='primary'
            size='lg'
          >
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        </Row>
      ) : (
        <>
          <Container
            className={`copingskills-fullscreen ${
              isMediumScreen ? 'pt-70' : 'pt-120'
            }`}
          >
            {/*video player*/}
            <div
              className={cn('coping-video mt-lg-3', {
                'mx-n32': isMediumScreen
              })}
            >
              <LessonVideo
                video={{
                  id: 0,
                  acf_extended: {
                    video_url: copingSkills.acf_extended.instruction_video,
                    captions_url: copingSkills.acf_extended.captions_url
                  }
                }}
                key={copingSkills.id}
              />
            </div>

            <Row className='coping-title'>
              <h4>{copingSkills.title.rendered}</h4>
            </Row>
            <Row className='coping-subtitle'>
              {parse(copingSkills.content.rendered)}
            </Row>
            <Row className='coping-button'>
              <Button
                size='lg'
                variant='primary'
                className='w-100 mt-3'
                onClick={() => handleClick()}
              >
                <span>I'm done</span>
              </Button>
            </Row>

            {author?.length > 0 && (
              <>
                <Row className='coping-author-title'>
                  <h4>About the author</h4>
                </Row>
                {
                  //author map array
                  author.map(item => (
                    <Row className='coping-author-component'>
                      <Author author={item} />
                    </Row>
                  ))
                }
              </>
            )}
          </Container>
        </>
      )}
    </>
  )
}
